export const kneeJointOptionsDefault: string[] = [
  '3R60',
  '3R80',
  '3WR95 Aqua Knie',
  'Andere',
  'Balance Knie OFM1',
  'Balance Knie OFM2',
  'C-Leg',
  'Genium',
  'Genium X3',
  'Gepardenknie',
  'Intuy Knee',
  'Kenevo',
  'Mauch Knie',
  'Mauch Knie Plus',
  'Paso Knie',
  'Rheo Knee XC',
  'Rheo Knie',
  'Total Knee 2000',
  'Total Knee 2100',
  'Totales Knie 1900',
  'Quadro',
  'Allux',
  'Genium X4',
  'Varia Flex',
  'Very Good',
  'Hytrek',
  'Locking Knee',
];
